import React, { Component } from "react";
import { toast } from 'react-toastify'
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AdmissionApi from "../../../Services/AdmissionApi";
import Paging from "../../Paging";
import moment from "moment";
import "./style.css";

class AdminScholarshipAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      showModal: true,
      scholarship: [],
      page: 1,
      pageSize: 6,
      totalPages: 1,
      scholarshipName: "",
      sponsoringInstitution: "",
      amountFrom: "",
      amountTo: "",
    };
    this.handleState = this.handleState.bind(this);
    this._openModal = this._openModal.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.updateListData = this.updateListData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);

    this.admissionsService = new AdmissionApi();
  }

  toggleModal = () => this.setState((state) => ({ showModal: !state.showModal }))

  handleState(value, data) {
    this.setState({
      detail: value,
    });

    this.props.sendDetail(value, data);
  }

  _openModal(item) {
    this.props.showForm(item);
  }

  updateState = (response) => {
    this.setState({
      scholarship: response.data._embedded.scholarships,
      showLoading: false,
      page: response.data.page,
      totalPages: response.data.pageCount,
    });
  };

  deleteItem = (item) => {
    confirmAlert({
      title: "Confirm ?",
      message: "Are You Sure you want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.admissionsService.deleteCredentials(
              res => {
                if(res.status === 200) {
                  toast.success(("Scholarship deleted successfully."))
                  this.updateData()
                }
              },
              "v1/alerts/scholarships",
              item.id
            );
          },
        },
        {
          label: "No",
          onClick: () => {
            console.log("Cancel");
          },
        },
      ],
    });
  }

  updateData = () => {
    this.getData();
  };

  getData(page = 1) {
    let filters = ''
    const {
      scholarshipName,
      sponsoringInstitution,
      amountFrom,
      amountTo,
    } = this.state

    if (scholarshipName) filters += `&name=${scholarshipName}`
    if (sponsoringInstitution) filters += `&sponsoring_institution=${sponsoringInstitution}`
    if (amountFrom) filters += `&amount_from=${amountFrom}`
    if (amountTo) filters += `&amount_to=${amountTo}`

    this.admissionsService.GetData(
      this.updateState,
      `v1/alerts/scholarships?page=${page}&pageSize=${this.state.pageSize}&column=created_at&order=desc${filters}`
    );
  }

  updateListData = (data) => {
    if (data) {
      this.updateState(data);
    } else {
      this.getData();
    }
  };

  UNSAFE_componentWillMount() {
    this.getData();
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = () => {
    this.getData()
  }

  clearFilter = () => {
    this.setState({
      scholarshipName: '',
      sponsoringInstitution: '',
      amountFrom: '',
      amountTo: '',
    }, this.getData)
  }

  handlePageChange = (page) => {
    this.getData(page)
  }

  render() {
    const {
      scholarship,
      page,
      totalPages,
      scholarshipName,
      sponsoringInstitution,
      amountFrom,
      amountTo,
    } = this.state

    const { showDetails, updateRoutePage } = this.props

    return (
      <section className="dash-alerts">
        <div className="alert-filter">
          <input
            id="scholarshipName"
            type="text"
            className="form-control alert-filter__input mr-2"
            placeholder="Scholarship Name"
            value={scholarshipName}
            onChange={this.handleFilterInputChange}
          />
          <input
            id="sponsoringInstitution"
            value={sponsoringInstitution}
            type="text"
            className="form-control alert-filter__input mr-2"
            placeholder="Sponsoring institution"
            onChange={this.handleFilterInputChange}
          />
          <input
            id="amountFrom"
            value={amountFrom}
            type="number"
            className="form-control alert-filter__input mr-2"
            placeholder="Amount From"
            onChange={this.handleFilterInputChange}
          />
          <input
            id="amountTo"
            value={amountTo}
            type="number"
            className="form-control alert-filter__input mr-2"
            placeholder="Amount To"
            onChange={this.handleFilterInputChange}
          />
          <button onClick={this.filterList} className="btn btn--primary">
            Submit
          </button>
          <button onClick={this.clearFilter} className="btn btn--default ml-2">
            Clear
          </button>
          <button onClick={() => updateRoutePage('new-scholarship-alerts')} className='btn btn--new ml-2'>
            <i className="icon-plus" />
          </button>
        </div>
        <table className="table table-responsive alert-table">
          <thead>
            <tr>
              <th scope="col">Scholarship Name</th>
              <th scope="col">Sponsoring Institution</th>
              <th scope="col">Amount</th>
              <th scope="col">Last Date to Apply</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {scholarship.map(item => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.sponsoring_institution}</td>
                <td>{item.amount}</td>
                <td>{moment(item.scholarship_last_date).format('DD/MM/YYYY')}</td>
                <td className="d-flex">
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('scholarship-alert-details', item)}>
                    <i className="icon-eye" />
                  </button>
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('new-scholarship-alerts', item)}>
                    <i className="icon-pencil" />
                  </button>
                  <button className="btn btn-link alert-table__link" onClick={() => this.deleteItem(item)}>
                    <i className="icon-trash" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Paging
          page={page}
          totalPages={totalPages}
          onChange={this.handlePageChange}
        />
      </section>
    )
  }
}

export default AdminScholarshipAlerts



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminScholarshipAlerts/index.js
 **/